<template>
  <div class="header-out">
    <header class="header" role="banner">
      <div class="header-in">

      <div class="h-back">
        <div class="h-top">
          <p class="logo">
            <a :href="url" title="株式会社ソナエルのTOPページへ">
              <img src="../../../assets/images/h_logo.png" width="233" alt="株式会社ソナエル">
            </a>
          </p>
          <p class="kouju">
            <a href="https://koujuren.jp/search_details.php?id=559" target="_blank" title="外部サイト高齢者住まい事業者団体連合会のページへ">
              <img width="88" height="33" src="../../../assets/images/main_logo.png" alt="高住連">
            </a>
          </p>
          <p class="p-mark">
            <a href="https://privacymark.jp/" target="_blank" title="外部サイトプライバシーマークのページへ">
              <img width="44" height="43" src="../../../assets/images/main_logo_privacy.png" alt="プライバシーマーク">
            </a>
          </p>
          <p class="h-cv2">
            <a href="tel:0120-65-4246">
              <img width="24" src="../../../assets/images/sf.png" alt=""><span>0120-65-4246</span>
            </a>
          </p>
          <a class="otoi" href="https://3816a0c3.form.kintoneapp.com/public/sonaeru-hp-toiawase" title="お問合せのページへ">
            <img width="21" src="../../../assets/images/mail.png" alt="">お問合せ
          </a>
        </div>

        <div class="h-bottom">
          <nav class="menubox globalnav-wrap">

            <div class="nav-button-wrap">
              <div class="nav-button">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <p class="pc-display-none sp-display-block">メニュー</p>
            </div>
            <ul class="globalnav">
              <li class="link-li-f">
                <a :href="url" title="株式会社ソナエルのTOPページへ">
                  <img width="60" src="../../../assets/images/m-top.png" alt="TOP">
                </a>
              </li>
              <li class="dropdown-btn">
                <a :href="`${url}/flow`">
                  <img src="../../../assets/images/m-service.png" width="123" height="22" alt="サービス案内">
                </a>
                <ul class="dropdown">
                  <li><a class="ho-link" href="/map/?lat=35.6834837&lon=139.7507583">老人ホーム検索</a></li>
                  <li><a class="ho-link" :href="`${url}/promise.html`">ソナエルの特長</a></li>
                  <li><a class="ho-link" :href="`${url}/flow.html`">ご入居までの流れ</a></li>
                  <li><a class="ho-link" :href="`${url}/download.html`">各種ダウンロード</a></li>
                  <li><a class="ho-link" :href="`${url}/q_a.html`">Q＆A集</a></li>
                </ul>
              </li>
              <li>
                <a :href="`${url}/staff/`" title="相談員紹介のページへ">
                  <img src="../../../assets/images/m-soudanin.png" width="107" height="23" alt="相談員紹介">
                </a>
              </li>
              <li class="dropdown-btn h-menu-sou">
                <a :href="`${url}/center/`">
                  <img src="../../../assets/images/m-soudanshitu.png" width="72" height="22" alt="相談室">
                </a>
                <ul class="dropdown dropdown2">
                  <li><a class="ho-link" :href="`${url}/center/akasaka.html`">赤坂相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/kinshicho.html`">錦糸町相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/kamata.html`">蒲田相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/meidaimae.html`">明大前相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/ikebukuro.html`">池袋相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/tachikawa.html`">立川相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/tama.html`">多摩相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/ebara-nakanobu.html`">荏原中延相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/sankenjaya.html`">三軒茶屋相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/kichijouji.html`">吉祥寺相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/machida.html`">町田相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/sapporo.html`">札幌相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/sendai.html`">仙台相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/mito.html`">水戸相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/saitama.html`">さいたま相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/funabashi.html`">船橋相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/yokohama.html`">横浜相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/center-minami.html`">センター南相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/mizoguchi.html`">溝の口相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/fujisawa.html`">藤沢相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/shizuoka.html`">静岡相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/nagoya.html`">金山相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/kyoto.html`">京都相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/umeda.html`">梅田相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/koube.html`">神戸相談室</a></li>
                  <li><a class="ho-link" :href="`${url}/center/hakata.html`">博多相談室</a></li>
                </ul>
              </li>
              <li class="dropdown-btn">
                <a title="会社案内のページへ" :href="`${url}/corporate/index.html`">
                  <img src="../../../assets/images/m-company.png" width="91" height="23" alt="会社案内">
                </a>
                <ul class="dropdown">
                  <li><a class="ho-link" :href="`${url}/aisatsu.html`">ご挨拶</a></li>
                  <li><a class="ho-link" :href="`${url}/corporate/index.html`">会社案内</a></li>
                  <li><a class="ho-link" :href="`${url}/lecture.html`">講演会について</a></li>
                  <li><a class="ho-link" href="https://job-gear.net/sonaeru/" target="_blank">採用情報</a></li>
                </ul>
              </li>
              <li>
                <a :href="`${url}/movies/`" title="ソナエルちゃんねるのページへ">
                  <img src="../../../assets/images/m-movie.png" width="144" height="21" alt="ソナエルちゃんねる">
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <ul class="h-cv pc-display-none sp-display-block">
        <li class="h-cv1">
          <a href="https://3816a0c3.form.kintoneapp.com/public/sonaeru-hp-toiawase" title="お問合せページへ">
            <img width="36" height="36" src="../../../assets/images/mail.png" alt="メールのアイコン"><span>お問い合わせ<br>フォーム</span>
          </a>
        </li>
        <li class="h-cv2">
          <a href="tel:0120-65-4246" title="電話お問合せ">
            <img width="39" height="39"  src="../../../assets/images/sf.png" alt="電話のアイコン"><span>電話お問い合わせ<br><b>0120-65-4246</b></span>
          </a>
        </li>
      </ul>
    </div>
    </header>
  </div>
</template>

<script>
  export default {
    name: 'AppHeader',
    components: {},
    data() {
      return {
        url: "https://www.sonaeru.co.jp" //本番
        //url: "https://stg.seniorhome.jp" //ステージング
      }
    },
    computed: {
    },
    methods: {
      showDropdown: function(e) {
        $(e.target).find('.dropdown').addClass('open');
      },
      hideDropdown: function(e) {
        $(e.target).find('.dropdown').removeClass('open');
      }
    },
  }

  $(window).on("scroll", function() {
    if ($(this).scrollTop() > 0) {
      $(".header").addClass("fixed");
    } else {
      $(".header").removeClass("fixed");
    }
  });


  $(function() {
    $('.nav-button-wrap').on('click', function() {
      if ($(this).hasClass('active')) {
        // スマホ用メニューが表示されていたとき
        $(this).removeClass('active');
        $('.globalnav').addClass('close');
        $('.globalnav-wrap , body').removeClass('open');
      } else {
        // スマホ用メニューが非表示の時
        $(this).addClass('active');
        $('.globalnav').removeClass('close');
        $('.globalnav-wrap , body').addClass('open');
      }
    });
  });

  $(function() {
    $('.dropdown-btn').hover(
      function() {
        //カーソルが重なった時
        $(this).children('.dropdown').addClass('open');
        $(this).children('.dropdown2').addClass('open2');
      }, function() {
        //カーソルが離れた時
        $(this).children('.dropdown').removeClass('open');
        $(this).children('.dropdown2').removeClass('open2')
      }
    );
  });

  // トップに戻るボタン
  $(function(){
    var pagetop = $('#page_top');
    pagetop.hide();

    $(window).scroll(function () {
       if ($(this).scrollTop() > 100) {
            pagetop.fadeIn();
       } else {
            pagetop.fadeOut();
       }
    });
    pagetop.click(function () {
       $('body, html').animate({ scrollTop: 0 }, 500);
       return false;
    });
  });

</script>
